import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { NgwWowService } from 'ngx-wow';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
import * as XLSX from 'xlsx';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

type AOA = any[][];


@Component({
  selector: 'app-create-doa-import',
  templateUrl: './create-doa-import.component.html',
  styleUrls: ['./create-doa-import.component.css']
})
export class CreateDoaImportComponent implements OnInit, AfterViewInit {
  isBright: boolean = true;
  isOpenDoctypeModel: boolean = true;
  selectedDocumentType: any = { docTypeId: 0, docTypeName: '', isCommentMandatory: false };
  RoleList: { RoleId: number, RoleName: string }[] = [];


  docTypeList: any = [];
  documentType_MST: any;

  workItemFieldList: any = [];

  @ViewChild('documentTypeModal') documentTypeModal: ElementRef;
  @ViewChild('errorduplicatedetails') errorduplicatedetails: ElementRef;
  @ViewChild('UrnList') UrnList: ElementRef;
  modalReference: any;

  ApproverList: { ApproverId: number, ApproverName: string }[] = [];
  field_ids: string = "0";
  lstSection = [];
  db_columns_values_list = {};
  frmInvoice: FormGroup;

  fileControlType = 'file';
  base64FileString: string = '';
  invoiceDocValidFileExtensions = [];
  @ViewChild('invFileUpload') fileInput: ElementRef;
  @ViewChild('DOAFileUpload') DOAfile: ElementRef;
  invoiceDocFileSize = {};

  //basic fields:
  Approvernm: any = "";
  Levelval: any = "";
  Managernm: any = "";

  //Submit param
  submitted: boolean = false;
  invoiceComment = 'invoiceComment';
  isDuplicate: boolean = false;
  lstDuplicateData: any = [];
  duplicateDataKeys: any = [];
  @ViewChild('duplicateInvoiceSubmittedModal') duplicateInvoiceSubmittedModal: ElementRef;
  potentialDuplicate: string = '';
  finalValue: string = 'Normal';
  selectedSubDocumentType: any = { subdocTypeId: 0, subdocTypeName: '' };
  attachmentList = [];
  createdInvoiceURN: string = '';
  @ViewChild('invoiceSubmittedModal') invoiceSubmittedModal: ElementRef;


  createComment: string = "";
  createComment_bulk: string = "";
  Comment_deletedao: string = "";
  wordsTotal_deletedao: any = 1000;
  wordsTotal_createdoa: any = 1000;
  wordsTotal_createdoa_bulk: any = 1000;
  //Grid Params
  ItemData: any;
  lstData = [];

  ItemData_pending: any;
  lstData_pending = [];

  ItemData_rejected: any;
  lstData_rejected = [];

  ItemData_audited: any;
  lstData_audited = [];

  ItemData_inactive: any;
  lstData_inactive = [];

  ItemData_DOAupload: any;
  lstData_DOAupload = [];

  columnsToHide_DOAupload: any = ['FILE_ID', 'FILE_PATH'];
  hyperlinkCols_DOAupload: any = ['document name', 'no. of invalid', 'no. of duplicates'];

  columnsToHide: any = ['DOA_DATA_ID', 'CREATED_BY', 'REQUEST_DOA_ID'];
  reportName: string = 'View/Approved';
  reportName_pending: string = 'Pending'
  reportName_rejected: string = 'Rejected'

  reportName_audited: string = 'Pending'
  reportName_inactive: string = 'Rejected'

  hyperlinkCols: any = ['Edit', 'Delete'];

  edit_flag: number = 0;


  //Bulk Upload Params
  browseMessage = "No file selected.";
  selectedExcelFile = this.browseMessage;
  fileTitle = "Choose file";

  excelDataTemplate: any;
  folderName: string;
  excelFileData: any = [];
  data: AOA;
  import_excel_file_data: any;
  db_col_name_array: any = [];
  field_name_array: any = [];


  //tab Params
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
  @ViewChild(MatTabGroup) tabGroupmain: MatTabGroup;
  tabindex: number = 0;
  current_dao_id: any;
  jsonData: string;

  //Usercreation
  loginidval: string = "";
  Usernameval: string = "";
  Emailval: string = "";
  rolselval: string

  @ViewChild('approvermenu') approvermenu: MatSelect;
  @ViewChild('Deletedoa_Modal') Deletedoa_Modal: TemplateRef<any>;

  ApproverData: any;
  addclick: boolean = false;
  currentpopup: string;

  Useraddbtn = "Add User"
  DOA_Datafieldlist: any[];
  uploadedfilePath: any;
  excelData: any;
  errordata: any[];
  fieldobj: {};
  searchobj: {};
  msg: string;
  isShown: boolean = false;
  search_data: any;
  searchflag: boolean = false;

  restrictedKeywords: any = [];
  modalReference_doadelete: any;
  isCommentExpand_deletedao: boolean = false;
  delete_DAO_data_id: any;

  isCommentExpand_createdoa: boolean = false;
  isCommentExpand_createdoa_bulk: boolean = false;
  lst_urnpendinglist: any;
  urnmsg: any;
  details: string;



  constructor(
    //private wowService: NgwWowService,
    private dataService: DataService,
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    private modalService: NgbModal,
    private encryptDecryptservice:EncryptDecryptService,
    private memorystore: MemoryStorageService
  ) {

    this.restrictedKeywords = this.commonService.getRestrictedKeywords();
  }

  ngOnInit(): void {

    this.getDocumentTypes();
    this.getApproverdata();
    this.getRole();

  }
  close_deletedao() {
    this.modalReference_doadelete.close();
    this.isCommentExpand_deletedao = false;
  }

  function(data, type) {

    if (type == "del") {
      this.wordsTotal_deletedao = 1000 - data.length;
    }
    if (type == "create") {
      this.wordsTotal_createdoa = 1000 - data.length;
    };
    if (type == "create_bulk") {
      this.wordsTotal_createdoa_bulk = 1000 - data.length;
    }
  }
  checkRestrictedKeywords(formControlName: string, useVariable = false) {

    let foundedRestrictedKeyword = [];
    let input
    input = formControlName;

    this.restrictedKeywords.forEach((keyword) => {
      if (input.includes(keyword.restrict)) {
        input = input.replaceAll(keyword.restrict, keyword.replace);

        foundedRestrictedKeyword.push(keyword.restrict);
      }
    });
    if (foundedRestrictedKeyword.length > 0) {
      this.Comment_deletedao = input
      this.commonService.showMessageBox(
        'We found some restricted keyword(s) entered in Comment.<br>It auto replaced by replacement keywords.<br>Please check given link for restricted keywords.',
        'Warning'
      );
    }
  }


  closeChangeDocumentTypeModal() {
    this.modalReference_doadelete.close();
    this.isCommentExpand_deletedao = false
  }

  getRole() {
    this.RoleList = [];
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('process_id', 0);
    params = params.append('doc_type_id', this.selectedDocumentType.docTypeId);
    params = params.append('pwm_id', 0);
    params = params.append('Is_Manager_flag', 1);
    this.dataService.getData('roles_DOA', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data.Table != null) {
          for (var i = 0; i < res.data.Table.length; i++) {
            this.RoleList.push({
              RoleId: res.data.Table[i].id,
              RoleName: res.data.Table[i].name,
            });
          }
        }
        //if there is only one role then select the role by default
        if (res.data.Table.length == 1) {
          this.rolselval = res.data.Table[0].id
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  ngAfterViewInit() {
    this.tabGroup.selectedIndex = 0;

  }
  getApproverdata() {

    this.ApproverList = [];
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    this.dataService.getData('Approver_DOA', params).subscribe(
      (res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res != null && res.data.Table != null) {
            this.ApproverData = res.data.Table;
            for (var i = 0; i < res.data.Table.length; i++) {
              this.ApproverList.push({
                ApproverId: res.data.Table[i].Id,
                ApproverName: res.data.Table[i].Name,
              });
            }
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      })
  }



  getDocumentTypes() {
    this.docTypeList = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('subgroup_id',this.encryptDecryptservice.encryptUsingAES256( this.commonService.selectedSubgroup));
    params = params.append('action', 'manual creation');
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    this.dataService
      .getData('document-types', params)
      .subscribe(
        (res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.data != null) {
              this.documentType_MST = res.data;
              for (var i = 0; i < res.data.length; i++) {
                this.docTypeList.push({
                  docTypeId: res.data[i].document_type_id,
                  docTypeName: res.data[i].document_type_name,
                  isCommentMandatory: res.data[i].is_comment_mandatory_for_create_workitem
                });
              }
              this.showModal(this.documentTypeModal, 'sm', 'doctype');
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }

        },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        }
      );
  }

  Create_user() {

    if (this.loginidval == "") {
      this.commonService.showMessageBox("Please fill Login Id field.", "Alert");
      return;
    }

    if (this.Usernameval == "") {
      this.commonService.showMessageBox("Please fill Name field.", "Alert");
      return;
    }

    if (this.Emailval == "") {
      this.commonService.showMessageBox("Please fill Email Id field.", "Alert");
      return;
    }
    let emailValidate = true
    let ep = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    emailValidate = ep.test(this.Emailval)
    if (emailValidate != true) {
      this.commonService.showMessageBox("Please enter valid Email Id field.", "Alert");
      return;

    }

    let params = {
      project_id: this.commonService.selectedProject,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      LOGIN_ID: this.loginidval,
      EMAIL_ID: this.Emailval,
      DISPLAY_NAME: this.Usernameval,
      Role_id: this.rolselval,
    };
    this.dataService.getData('Create_new_User_DOA', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        let msg = res.data.Table[0].Message
        if (res.data.Table[0].Flag == 1) {
          this.commonService.showMessageBox(msg, "Success");
        }
        else {
          this.commonService.showMessageBox(msg, "Alert");
        }
        this.loginidval = "",
          this.Emailval = "",
          this.Usernameval = "",
          this.rolselval = "0"
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })

  }


  async onChangeDoctype(docType: any) {
    this.createComment = "";
    this.isOpenDoctypeModel = false;
    this.selectedDocumentType = docType;

    this.getField_Mapping_Ids();

    this.modalReference.close();

    if (this.isShown) {
      this.isShown = false;
    }

  }
  getField_Mapping_Ids() {

    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('doc_id', this.selectedDocumentType.docTypeId);
    this.dataService.getData('Field_Mapping_IDs_DOA', params).subscribe(
      (res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res != null && res.data.Table != null) {
            this.field_ids = res.data.Table[0].id
            this.getWorkItemFields();
            this.getDOAdata();

          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      })
      }

  getDOAdata() {
    this.getDOAdata_current();
    this.getDOAdata_pending();
    this.getDOAdata_rejected();
    this.getDOAupload_details();
    this.getDOAdata_audited();
    this.getDOAdata_inactive();
    this.createComment_bulk = "";
    this.Comment_deletedao = "";
  }
  getDOAupload_details() {
    let params = {
      project_id: this.commonService.selectedProject,
      doc_id: this.selectedDocumentType.docTypeId,
    };
    this.dataService.getData('getDOAupload_details', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        this.ItemData_DOAupload = res.data.Table;
        this.lstData_DOAupload = this.ItemData_DOAupload;
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })
  }


  getDOAdata_current() {

    let params = {
      project_id: Number(this.commonService.selectedProject),
      doc_id: Number(this.selectedDocumentType.docTypeId),
      Field_ids: this.field_ids,
      searchobj: this.searchobj,
      searchflag: this.searchflag
    };

    this.dataService.postData('getDOAdata', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        this.ItemData = res.data.Table;
        this.ItemData.forEach(e => {
          //e["action_icon_Edit"] = "edit";

          if (e["DOA status"] == "ACTIVE") {
            e["action_icon_Delete"] = "delete"
          }
          else {
            e["action_icon_Delete"] = ""
          }

        })
        let count = res.data.Table.length;
        this.reportName = "View/Approved" + " ( " + count + " ) ";
        this.lstData = this.ItemData;
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })

  }

  getDOAdata_pending() {
    let params = {
      project_id: this.commonService.selectedProject,
      doc_id: this.selectedDocumentType.docTypeId,
      Field_ids: this.field_ids,
      searchobj: this.searchobj,
      searchflag: this.searchflag
    };
    this.dataService.postData('getDOAdata_pending', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        this.ItemData_pending = res.data.Table;
        let count = res.data.Table.length;
        this.reportName_pending = "Pending" + " ( " + count + " ) ";
        this.ItemData_pending = this.ItemData_pending.map(item => {
          delete item.action_checkbox_button;
          return item;
        });
        this.lstData_pending = this.ItemData_pending;
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })

  }


  getDOAdata_rejected() {
    let params = {
      project_id: this.commonService.selectedProject,
      doc_id: this.selectedDocumentType.docTypeId,
      Field_ids: this.field_ids,
      searchobj: this.searchobj,
      searchflag: this.searchflag
    };
    this.dataService.postData('getDOAdata_rejected', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        this.ItemData_rejected = res.data.Table;
        // this.ItemData_rejected.forEach(e => {
        //   e["action_icon_Edit"] = "edit";
        //   e["action_icon_Delete"] = "delete"
        // })
        let count = res.data.Table.length;
        this.reportName_rejected = "Rejected" + " ( " + count + " ) ";
        this.lstData_rejected = this.ItemData_rejected;
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })

  }

  getDOAdata_audited() {
    let params = {
      project_id: this.commonService.selectedProject,
      doc_id: this.selectedDocumentType.docTypeId,
      Field_ids: this.field_ids,
      searchobj: this.searchobj,
      searchflag: this.searchflag
    };
    this.dataService.postData('getDOAdata_audited', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        this.ItemData_audited = res.data.Table;
        let count = res.data.Table.length;
        this.reportName_audited = "Audited" + " ( " + count + " ) ";
        this.lstData_audited = this.ItemData_audited;
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })

  }
  getDOAdata_inactive() {
    let params = {
      project_id: this.commonService.selectedProject,
      doc_id: this.selectedDocumentType.docTypeId,
      Field_ids: this.field_ids,
      searchobj: this.searchobj,
      searchflag: this.searchflag
    };
    this.dataService.postData('getDOAdata_inactive', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        this.ItemData_inactive = res.data.Table;
        let count = res.data.Table.length;
        this.reportName_inactive = "Inactive" + " ( " + count + " ) ";
        this.lstData_inactive = this.ItemData_inactive;
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })

  }


  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    this.tabindex = tabChangeEvent.index;
    // this.onResetButtonClick();
    //  this.getField_Mapping_Ids();
  }

  onGridCellClick(event: any) {
    var val = "";
    if (event.columnName == 'action_icon_Edit') {
      val = event.rowData.DOA_DATA_ID;
      this.edit_DAO_data(val);
    }
    if (event.columnName == 'action_icon_Delete') {
      val = event.rowData.DOA_DATA_ID;
      this.details = "";

      Object.entries(event.rowData).forEach(([key, value]) => {
        if (!key.startsWith("Approver") && !key.startsWith("action") && !key.startsWith("DOA") && !key.startsWith("Inv")) {
          this.details = this.details + "  " + key + " :" + value + " ,  ";
        }

      });
      this.details = this.details.trim();
      this.details = this.details.substring(0, Number(this.details.length) - 2)
      this.delete_DAO_data(val)
    }
    if (event.columnName == 'action_radio_button') {
      val = event.rowData.Id;
      this.selectusername(val);
    }

    if (event.columnName == 'Document name') {
      val = event.rowData.FILE_ID;
      this.downloadDOAUploadfile(val);
    }

    if (event.columnName == 'No. Of Invalid') {
      val = event.rowData.FILE_ID;
      this.showerrordetails(val, event.rowData["No. Of Invalid"], 0);
    }
    if (event.columnName == 'No. Of Duplicates') {
      val = event.rowData.FILE_ID;
      this.showerrordetails(val, event.rowData["No. Of Duplicates"], 1);
    }

  }

  onSearchfilterClick(event: any) {
    this.searchobj = {};


    event.forEach(element => {
      if (element.controlType == "DROPDOWN") {
        this.searchobj[element.db_column_name] = element.displayText;
      }

    });
    this.searchflag = true
    this.getDOAdata_current();
    this.getDOAdata_pending();
    this.getDOAdata_rejected();
    this.getDOAdata_audited();
    this.getDOAdata_inactive();

  }

  searchview() {
    this.isShown = !this.isShown;
  }


  showerrordetails(file_id: string, count, type) {

    if (type == 0) {
      this.msg = "Error"
    }
    else {
      this.msg = "Duplicate"
    }
    if (count == 0) {
      this.commonService.showMessageBox("There is no " + this.msg + " records", "Alert");
      return;
    }

    this.errordata = [];
    let params = {
      project_id: this.commonService.selectedProject,
      doc_id: this.selectedDocumentType.docTypeId,
      file_id: file_id,
      field_ids: this.field_ids,
      duplicateflag: type
    };
    this.dataService.getData('getDOAUploadfile_errordetails', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        this.errordata = res.data.Table
        this.showModal(this.errorduplicatedetails, 'lg', 'doctype');
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })


  }
  selectusername(val: string) {

    if (this.currentpopup == "Approver") {
      this.Approvernm = val;
    }
    else if (this.currentpopup = "Manager") {
      this.Managernm = val;
    }


  }




  edit_DAO_data(val) {
    this.current_dao_id = val
    this.edit_flag = 1

    let params = {
      project_id: this.commonService.selectedProject,
      doc_id: this.selectedDocumentType.docTypeId,
      Field_ids: this.field_ids,
      DOA_id: val,
      tabindex: this.tabindex
    };
    this.dataService.getData('getDOAdata_forupdate', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        this.Approvernm = res.data.Table[0].approver_name;
        this.Levelval = res.data.Table[0].level,
          this.Managernm = res.data.Table[0].manager_name
        this.workItemFieldList.forEach(field => {
          var col_name = field.db_column_name;
          var val = res.data.Table[0][col_name.toLowerCase()];
          if (field.control_type != "DROPDOWN") {
            this.frmInvoice.controls[col_name].setValue(val);
          }
          else {
            field.options.forEach(f => {
              if (f.name == val) {
                this.frmInvoice.controls[col_name].setValue(val);
              }
            })
          }

        })
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })
  }


  delete_DAO_data(val) {
    this.delete_DAO_data_id = val;
    let params = {
      project_id: Number(this.commonService.selectedProject),
      doc_id: Number(this.selectedDocumentType.docTypeId),
      DOA_id: Number(val)
    };
    this.dataService.getData('check_URNpendinglist', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.status == false) {
          this.urnmsg = res.error_message;
          this.lst_urnpendinglist = res.data.Table
          if (this.lst_urnpendinglist != null) {
            this.showModal(this.UrnList, 'lg', 'doctype');
          }
        }
        else {
          const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            disableClose: true,
            data: {
              message: 'Are you sure want to delete the data?',
              buttonText: {
                ok: 'Yes',
                cancel: 'No',
              },
            },
          });
          dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {

              this.modalReference_doadelete = this.modalService.open(this.Deletedoa_Modal, {
                size: 'lg', centered: true, backdrop: 'static',
                keyboard: false
              });

            }
          });
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });

  }

  Raise_del_request() {
    let params = {
      project_id: this.commonService.selectedProject,
      doc_id: this.selectedDocumentType.docTypeId,
      DOA_id: this.delete_DAO_data_id,
      Field_ids: this.field_ids,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      comment: this.Comment_deletedao
    };
    this.dataService.getData('getDOAdata_delete', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.status == false) {
          this.commonService.showMessageBox('Could not proceed with the request.', 'Error');
        }
        else {
          this.commonService.showMessageBox('Data Delete requested successfully.', 'Success');

        }
        this.modalReference_doadelete.close();
        this.getDOAdata();
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })
  }

  update_DAO_data() {

  }

  getWorkItemFields() {

    this.workItemFieldList = [];
    this.DOA_Datafieldlist = [];

    this.db_col_name_array = [];
    this.field_name_array = [];

    this.fieldobj = {};

    let params = {
      project_id: this.commonService.selectedProject,
      doc_id: this.selectedDocumentType.docTypeId,
      Field_ids: this.field_ids
    };
    this.dataService.getData('dynamic_fields_DOA', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != null && res.data != null)

          this.workItemFieldList = res.data.Table;
        else this.workItemFieldList = [];

        this.lstSection = [];
        this.workItemFieldList.forEach(item => {

          if (this.lstSection.findIndex(s => s.SECTION_NAME == item.section_name) == -1) {
            let lst = this.workItemFieldList.filter(x => x.section_name == item.section_name);
            this.lstSection.push({ SECTION_ID: item.section_name, SECTION_NAME: item.section_name, FIELDS_DETAIL: lst, SECTION_ORDER: item.section_order });
          }
        });
        const formControls: any = {};
        this.workItemFieldList.forEach(async (field) => {

          field.is_mandatory = 1
          // field.is_readonly = 0;
          this.db_col_name_array.push(field.db_column_name);
          this.field_name_array.push(field.field_name);

          this.fieldobj[field.db_column_name] = field.field_name;

          let fieldValidators = [];
          if (
            field.control_type == 'FILE' ||
            field.is_mandatory == 1
          ) {
            fieldValidators = [Validators.required];
          }

          let defaultValue =
            field.control_type == 'DATE' ? null :
              field.control_type == 'DROPDOWN' ? field.dropdown_type == 'PredefinedMst' && field.dropdown_value != null ? +field.dropdown_value.trim() : null :
                field.control_type == 'CHECKBOX' ? false : '';

          this.db_columns_values_list[field.db_column_name] = defaultValue;

          formControls[field.db_column_name] =
            new FormControl({
              value: defaultValue,
              disabled: field.is_readonly == 1
            }, fieldValidators);

          if (field.control_type == 'TEXTBOX') {
            field.value_type = field.validation_type == 'NUMERIC' ? 'number' : 'text';
          }
          if (field.actions != null) {
            field.actions = JSON.parse(field.actions);
          }
          if (field.control_type == 'DROPDOWN') {

            //By Prakash
            //field.options = JSON.parse(field.options);
            let magnify_dependant_fields = {};
            let dropdown_dependant_parameter = {};
            if (field.magnify_dependant_fields != null && field.magnify_dependant_fields != undefined) {
              magnify_dependant_fields = JSON.parse(field.magnify_dependant_fields);
              Object.keys(magnify_dependant_fields).forEach(x => {

                let field_value = this.db_columns_values_list[magnify_dependant_fields[x]];
                if (field_value != null && field_value != '' && field_value != undefined) {
                  dropdown_dependant_parameter[x] = field_value.toString();
                }
              });
            }
            field.dropdown_dependant_parameter = dropdown_dependant_parameter;

            if (field.is_autocomplete == 0 && field.is_readonly == 0) {
              field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, 0, dropdown_dependant_parameter);
              //this.db_columns_values_list[field.db_column_name + "_option"] = field.options
            }
            else if (field.is_autocomplete == 0 && field.is_readonly == 1) {
              if (defaultValue != null && defaultValue != undefined)
                field.field_value = defaultValue;
              if (field.field_value == "" || field.field_value == undefined)
                field.field_value = 0;

              field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, field.field_value, dropdown_dependant_parameter);
            }
            else {
              if (field.field_value == "" || field.field_value == undefined)
                field.field_value = "";

              field.options = await this.commonService.getAutocomplete_dropdowndata(field.field_mapping_detail_id, field.field_value, 'id')
              //this.db_columns_values_list[field.db_column_name + "_option"] = field.options
            }
            //Gabriel start
            //dependant field event called for page load if fields readonly
            if (field.is_dependant == 1 && field.field_value != null) {
              // this.getDependantFields(field.field_mapping_detail_id, fieldVal);                    
              this.getDependantFields(
                field.field_mapping_detail_id, field.field_value
              );
              //field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, 0, dropdown_dependant_parameter);
              //field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, field.field_value, dropdown_dependant_parameter);
            }
            //Gabriel end

            //field.options = [...new Map(field.options.map(item => [item['name'], item])).values()];
            // field.options.splice(0, 0, { id: 0, name: '-- Select --' });
          }
          this.DOA_Datafieldlist.push(field)
          this.DOA_Datafieldlist = this.DOA_Datafieldlist.sort((a, b) => {
            if (a.field_order < b.field_order) {
              return -1;
            }
            return a;
          });
        });

        formControls["commentsection"] =
          new FormControl({
            value: "",
          }, [Validators.required]);


        this.frmInvoice = new FormGroup(formControls);

        this.frmInvoice.controls["commentsection"].setValue("");
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  onResetButtonClick() {
    this.edit_flag = 0;
    this.current_dao_id = 0;

    this.Approvernm = 0;
    this.Levelval = 1;
    this.Managernm = 0;

    this.frmInvoice.reset();
    this.frmInvoice.markAsPristine();
    this.frmInvoice.markAsUntouched();




  }
  get f() {
    return this.frmInvoice.controls;
  }



  changeTextFieldValue(field: any) {
    let field_value = this.frmInvoice.get(field.db_column_name).value;

    if (field.is_dependant == 1) {
      this.getDependantFields(
        field.field_mapping_detail_id,
        field_value
      );
    }

    if (field.actions != null) {
      // execute actions/query if any
      field.actions.forEach(action => {
        if (action.action_type == 'SET_VALUE' && action.execute_mode == 'FORMULA' && action.action_trigger == 'VALUE_CHANGE') {
          let formula = action.formula;

          action.formula_fields.split(",").forEach(f => {
            let field_value = this.frmInvoice.get(f).value;
            formula = formula.replace(f, (field_value != "" && field_value != undefined && field_value != null) ? Number(field_value) : 0);
          });
          let formulaValue = eval(formula);

          this.frmInvoice.get(action.target_db_column_name)
            .setValue(formulaValue);
        }
      });
    }

    if (field.validation_type == 'NUMERIC' || field.validation_type == 'AMOUNT') {
      field_value = this.commonService.handleNumberInput(field, field_value);
      this.frmInvoice.get(field.db_column_name).setValue(field_value);
    }

  }

  getDependantFields(fieldMappingDetailId: number, selectedValue: any) {
    let params = {
      field_mapping_detail_id: fieldMappingDetailId,
      selected_value: selectedValue,
      xusrid:this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
    };

    this.dataService.getData('dependant', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != undefined) {
          if (res.data.length > 0) {
            res.data.forEach((ele) => {
              ele.values = JSON.parse(ele.values);
              if (ele.control_type == 'DROPDOWN') {
                const uniqueData = [...new Map(ele.values.map(item => [item['name'], item])).values()];
                this.workItemFieldList.find(
                  (x) => x.db_column_name == ele.db_column_name
                ).options = uniqueData;
                if (uniqueData.length == 1) {
                  this.frmInvoice
                    .get(ele.db_column_name)
                    .setValue(uniqueData[0]['id']);
                }
              } else if (ele.control_type == 'TEXTBOX') {
                if (ele.values.length > 0) {
                  this.frmInvoice
                    .get(ele.db_column_name)
                    .setValue(ele.values[0].name);
                } else {
                  this.frmInvoice.get(ele.db_column_name).setValue('');
                }
              }
            });
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    }
    );
  }





  callOnAutoCompleteChangedEvent(data) {
    this.frmInvoice.get(data.db_column_name).setValue(data.fieldValue);
    if (data.control_type == 'DROPDOWN') {
      this.changeDropdownFieldValue(data);
    } else if (data.control_type == 'TEXTBOX') {
      this.changeTextFieldValue(data);
    }
  }

  changeDropdownFieldValue(field: any) {
    if (field.is_dependant == 1) {
      this.getDependantFields(
        field.field_mapping_detail_id,
        this.frmInvoice.get(field.db_column_name).value
      );
    }
  }


  openAdvanceSearchModal(fieldMappingDetailId: number, magnifyDependantFields: string = null, predefinedTableColumnName: string = 'id') {

    let dependantFieldValues = {};
    if (magnifyDependantFields != null) {
      magnifyDependantFields = JSON.parse(magnifyDependantFields);
      Object.keys(magnifyDependantFields).forEach(x => {
        let field_value = this.frmInvoice.get(magnifyDependantFields[x]).value;
        if (field_value != null && field_value != '' && field_value != undefined) {
          // let field = this.workItemFieldList.find(f => f.db_column_name == magnifyDependantFields[x]);
          // if (field != undefined && field.control_type == 'DROPDOWN') {
          //   field_value = field.options.find(d => d.id == field_value).name;
          // }
          dependantFieldValues[x] = field_value.toString();
        }
      });
    }

    const modalRef = this.modalService.open(MagnifyFieldSearchComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.fieldMappingDetailId = fieldMappingDetailId;
    modalRef.componentInstance.predefinedTableColumnName = predefinedTableColumnName;
    modalRef.componentInstance.dependantFieldValues = dependantFieldValues;
    modalRef.componentInstance.selectRecord.subscribe((res) => {

      const selectedField = this.workItemFieldList.find(
        (x) => x.field_mapping_detail_id == res.fieldId
      );

      if (selectedField.control_type == 'DROPDOWN') {
        const selectedOptionField = selectedField.options.find(
          (x) => x.id == res.fieldValue
        );
        this.frmInvoice
          .get(selectedField.db_column_name)
          .setValue(selectedOptionField['id']);
        this.changeDropdownFieldValue(selectedField);
      } else if (selectedField.control_type == 'TEXTBOX') {
        this.frmInvoice
          .get(selectedField.db_column_name)
          .setValue(res.fieldValue.toString());
        this.changeTextFieldValue(selectedField);
      }
      modalRef.close();
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    });
  }


  omit_special_char(e, regExp) {
    // var k;
    // k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    // return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));

    //var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    if (regExp == "" || regExp == null || regExp == undefined)
      return true;

    var regex = new RegExp(regExp);
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }

    e.preventDefault();
    return false;
  }

  omit_onPaste(e) {
    ///(paste)="onPaste($event)" add this line into html input.
    e.preventDefault();
    return false;
  }

  onTextBoxKeyPressEvent(event: any, field: any) {
    const reg = this.commonService.getRegForDecimal;
    let input = event.target.value + String.fromCharCode(event.charCode);

    if (!reg.test(input)) {
      event.preventDefault();
    }
  }

  showModal(modelTemplate, modalSize: string = 'lg', popup: string) {

    if (popup == "Approver" || popup == "Manager") {
      $("#userbtn").addClass("smallButton")
      $("#userbtn").removeClass("resetButton")
      this.Useraddbtn = "Add User"
      this.addclick = false
    }


    if (popup == "Approver") {
      this.currentpopup = "Approver"
    }
    else if (popup == "Manager") {
      this.currentpopup = "Manager"
    }
    else {
      this.currentpopup = ""
    }

    this.approvermenu.close();
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });

    this.approvermenu.close();
  }

  showModal_gen(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  addclicked(e) {
    if ($("#userbtn").hasClass("smallButton")) {
      $("#userbtn").addClass("resetButton")
      $("#userbtn").removeClass("smallButton")
    }
    else {
      $("#userbtn").addClass("smallButton")
      $("#userbtn").removeClass("resetButton")
    }

    if (this.addclick == true) {
      this.Useraddbtn = "Add User"

    }
    else {
      this.Useraddbtn = "Go Back"
    }

    this.addclick = !this.addclick


  }

  downloadExcelTemplate() {
    this.excelDataTemplate = [];
    let params = {
      project_id: this.commonService.selectedProject,
      doc_id: this.selectedDocumentType.docTypeId,
      Field_ids: this.field_ids
    };
    this.dataService.getData('getDOAdataexcel', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        this.excelDataTemplate = res.data.Table
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.excelDataTemplate);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, ws, 'DOAData');

        XLSX.writeFile(wb, 'DOAData.xlsx');
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })
  }

  downloadDOAUploadfile(file_id) {
    this.excelData = [];
    let params = {
      project_id: this.commonService.selectedProject,
      doc_id: this.selectedDocumentType.docTypeId,
      file_id: file_id,
      field_ids: this.field_ids
    };
    this.dataService.getData('getDOAUploadfile', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        this.excelData = res.data.Table
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.excelData);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, ws, 'DOAData');

        XLSX.writeFile(wb, 'DOAData.xlsx');
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })
  }

  onSelectExcelFile(file) {
    this.selectedExcelFile = file.target.files[0].name;
    let workBook = null;
    const reader = new FileReader();
    const excelfile = file.target.files[0];
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });

      const sheet = workBook.Sheets['DOAData'];
      this.excelFileData = XLSX.utils.sheet_to_json(sheet, { defval: "" });


      if (this.excelFileData == undefined || this.excelFileData.length == 0) {
        this.commonService.showMessageBox("No data found in file.", "Alert");
        this.fileInput.nativeElement.value = '';
        this.selectedExcelFile = this.browseMessage;
        return;
      }

      let missingCol = "";
      let cols = Object.keys(this.excelFileData[0]);
      this.workItemFieldList.forEach(f => {
        if (cols.findIndex(a => a == f.field_name) == -1) {
          missingCol = (missingCol == '') ? f.field_name : missingCol + ', ' + f.field_name;
        }
      });

      if (missingCol != "") {
        this.commonService.showMessageBox("Below column(s) are missing in excel data file.<br>" + missingCol, "Alert");
        this.fileInput.nativeElement.value = '';
        this.selectedExcelFile = this.browseMessage;
        return;
      }

      //-------------------------------
      //File upload on temp location on server
      let reader1 = new FileReader();
      reader1.onload = (e: any) => {
        let base64FileString = reader1.result.toString();
        this.folderName = this.commonService.formatDate(new Date(), "yyyyMMddhhmmss");
        let body = [];
        body.push({
          FileName: this.selectedExcelFile,
          FileData: base64FileString,
          FolderName: this.folderName
        });
        this.import_excel_file_data = body;
        // this.dataService.postData("DOA_file_upload", body, this.dataService.apiURL_Core).subscribe(res => {
        //   if (res != null && res != undefined) {
        //     if (res.status =="Success") {

        //     }
        //   }

        // });
      };

      reader1.readAsDataURL(excelfile);
      //-------------------------------



    }
    reader.readAsBinaryString(excelfile);
    // this.fileInput.nativeElement.value = '';
  }

  async saveDOAData() {

    if (this.createComment_bulk == "") {
      this.commonService.showMessageBox("Please provide comments", 'Alert');
      return;
    }


    let body = {
      DOA_data_dt: this.excelFileData,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      doc_id: this.selectedDocumentType.docTypeId,
      project_id: this.commonService.selectedProject,
      file: this.import_excel_file_data,
      db_col_name_array: this.db_col_name_array.join(","),
      field_name_array: this.field_name_array.join(","),
      fieldobj: this.fieldobj,
      comments: this.createComment_bulk
    };

    this.dataService.postData("DOA_Data_bulk_import", body).subscribe(res => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.status == true) {
          this.commonService.showMessageBox(res.error_message, 'Sucess');
        }
        else if (res.status == false) {
          this.commonService.showMessageBox(res.error_message, 'Alert');
        }
        else {
          this.commonService.showMessageBox("Error occured in uploading", 'Alert');
        }
        this.getDOAdata();
        this.fileInput.nativeElement.value = '';
        this.selectedExcelFile = this.browseMessage;
        this.import_excel_file_data = [];
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });


  }


  submitInvoice() {

    this.submitted = true;
    let isSubmitValid = true;
    let invalidSubmitMsg = '';
    let invalidLengthMsg = '';

    if (this.Approvernm == 0) {
      this.commonService.showMessageBox("Please select an approver", 'Alert');
      return;
    }
    if (this.Levelval == 0) {
      this.commonService.showMessageBox("Please select a valid level", 'Alert');
      return;
    }

    if (this.frmInvoice.invalid) {
      invalidSubmitMsg += 'Please fill the required field(s)\r <br/>';
      isSubmitValid = false;
    }

    // if (this.frmInvoice.value['invoiceComment'].trim() == '') {
    //   invalidSubmitMsg += 'Comment is mandatory\r <br/>';
    //   isSubmitValid = false;
    // }

    if (
      this.workItemFieldList.findIndex((x) => x.control_type == 'FILE') != -1 &&
      this.base64FileString == ''
    ) {
      invalidSubmitMsg += 'Please select file\r <br/>';
      isSubmitValid = false;
    }

    // if (this.selectedDocumentType.isCommentMandatory && (this.frmInvoice.get(this.invoiceComment).value == '' ||
    //   this.frmInvoice.get(this.invoiceComment).value == undefined ||
    //   this.frmInvoice.get(this.invoiceComment).value == null)
    // ) {
    //   invalidSubmitMsg += 'Comment is mandatory.\r <br/>';
    //   isSubmitValid = false;
    // }

    if (!isSubmitValid) {
      this.commonService.showMessageBox(invalidSubmitMsg, 'Alert');
      return;
    }

    let fieldsData = [];
    let lst = [];
    let lstRow = this.frmInvoice.getRawValue();
    let formValue = "";

    this.workItemFieldList.forEach(field => {

      formValue = lstRow[field.db_column_name];
      let displayText = '';

      if (formValue != undefined && formValue != null)
        formValue = formValue.toString();
      else
        formValue = '';


      if (field.value_type == "number") {
        formValue = parseFloat(formValue.toString()).toString();
      }
      // START: field length validation
      if (field.is_readonly == 0 && field.control_type == 'TEXTBOX') {
        let fix_length = 0;
        if (field.min_length == field.max_length) {
          fix_length = field.min_length;
        }

        if (fix_length > 0 && (field.is_mandatory == 1 || formValue != '')) {

          if (formValue.toString().length != fix_length) {
            if (invalidLengthMsg == "")
              invalidLengthMsg = "Length of " + field.field_name + " must be " + fix_length + ".";
            else
              invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of " + field.field_name + " must be " + fix_length + ".";
          }
        }

        if (fix_length == 0 && field.min_length > 0 && (field.is_mandatory == 1 || formValue != '')) {
          if (formValue.toString().length < field.min_length) {
            if (invalidLengthMsg == "")
              invalidLengthMsg = "Length of " + field.field_name + " is min " + field.min_length + ".";
            else
              invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of " + field.field_name + " is min " + field.min_length + ".";
          }
        }

        if (fix_length == 0 && field.max_length > 0) {
          if (formValue.toString().length > field.max_length) {
            if (invalidLengthMsg == "")
              invalidLengthMsg = "Length of " + field.field_name + " is up to " + field.max_length + ".";
            else
              invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of " + field.field_name + " is up to " + field.max_length + ".";
          }
        }
      }
      // END: field length validation

      let value: string = ""

      if (field.control_type == "DATE") {
        value = this.commonService.dateFormating(formValue);
      }
      else {
        value = formValue;
      }

      if (field.control_type == "DROPDOWN") {
        displayText = field.options.find(d => d.id == value) ?.name;
      }

      fieldsData.push({
        db_column_name: field.db_column_name,
        field_val: value.toString().trim(),
        controlType: field.control_type,
        displayText: displayText == undefined ? '' : displayText
      });

      lst.push({
        ParameterName: field.db_column_name,
        ParameterValue: value.toString().trim()
      });

    });

    if (invalidLengthMsg != '') {
      this.commonService.showMessageBox(invalidLengthMsg, 'Alert');
      return;
    }




    let params = {
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      fields_data: fieldsData,
      document_type_id: Number(this.selectedDocumentType.docTypeId),
      project_id: Number(this.commonService.selectedProject),
      Approver_name: this.Approvernm,
      Approver_level: this.Levelval,
      Manager_name: this.Managernm == 0 ? "" : this.Managernm,
      Field_id: this.field_ids,
      DOA_id: this.current_dao_id,
      Edit_Flag: this.edit_flag,
      tabindex: this.tabindex,
      comments: lstRow["commentsection"]

    };

    this.dataService.postData('DOA_Data_config', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.status == true) {
          this.commonService.showMessageBox(res.error_message, 'Sucess');
        }
        if (res.status == false) {
          this.commonService.showMessageBox(res.error_message, 'Error');
        }
        this.getDOAdata();
        this.onResetButtonClick();
        this.getField_Mapping_Ids();
        this.frmInvoice.controls["commentsection"].setValue("");
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })


  }

  submitAttachments(response_data: any) {
    this.attachmentList.forEach((item) => {
      let attachmentBody = {
        document_detail_id: Number(response_data.document_detail_id),
        document_type_id: Number(this.selectedDocumentType.docTypeId),
        project_id: Number(this.commonService.selectedProject),
        process_id: Number(response_data.document_process_id),
        // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
        user_id: Number(this.memorystore.getItem('userId')),
        attachment_name: item.name,
        attachment_encoded: item.file,
        document_history_id: response_data.document_history_id,
        module_name: 'AP'
      };

      this.dataService.postData('transaction-attachments', attachmentBody).subscribe((res) => {
        if (res) {
          if (res != null && (res.errorMessage == null || res.errorMessage == "")) {

          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }
          // this.uploadFileName = '';
          // this.fileBase64FileString = '';
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
    });
  }


}
